import { EditProfileScreen } from '@/screens/profile-screen/EditProfileScreen'

export default function () {
  return <EditProfileScreen />
}
